import React from 'react'
import type { TourStepProps } from 'antd'
import { Typography } from 'antd'
import { Route, Layers, Calendar, Settings2 } from 'lucide-react'
import i18next from 'i18next'

const { Text, Paragraph } = Typography

const getElement = (selector: string) => () => document.querySelector<HTMLElement>(selector)!

const iconStyle = { verticalAlign: '-0.125em', marginRight: 8, opacity: 0.6 } as const

export const getAccountantSteps = (): TourStepProps[] => [
  {
    title: i18next.t('tour:welcome'),
    description: <Paragraph>{i18next.t('tour:tips')}</Paragraph>
  },
  {
    target: getElement('.settings-menu'),
    title: i18next.t('tour:accountant-settings'),
    description: (
      <ol style={{ textAlign: 'left', paddingInlineStart: 20 }}>
        <li>
          <Text>{i18next.t('tour:add-accountan-user')}</Text>
        </li>
        <li>
          <Text>{i18next.t('tour:keyfigures-notifications')}</Text>
        </li>
        <li>
          <Text>{i18next.t('tour:add-contract')}</Text>
        </li>
      </ol>
    )
  },
  {
    target: getElement('.context-company-select'),
    title: i18next.t('tour:company-select'),
    description: undefined
  },
  {
    target: getElement('.filter-toolbar'),
    title: i18next.t('tour:magnifier'),
    description: (
      <div style={{ textAlign: 'left' }}>
        <Paragraph>
          <Route size={14} style={iconStyle} />
          {i18next.t('tour:budgetscenarios')}
        </Paragraph>
        <Paragraph>
          <Layers size={14} style={iconStyle} />
          {i18next.t('tour:dimensions')}
        </Paragraph>
        <Paragraph>
          <Calendar size={14} style={iconStyle} />
          {i18next.t('tour:date-filters')}
        </Paragraph>
        <Paragraph>
          <Settings2 size={14} style={iconStyle} />
          {i18next.t('tour:view-settings')}
        </Paragraph>
        <Paragraph style={{ marginBottom: 0 }}>
          <Settings2 size={14} style={iconStyle} />
          {i18next.t('tour:hide-empty-rows')}
        </Paragraph>
      </div>
    )
  },
  {
    target: getElement('.settings-menu'),
    title: i18next.t('tour:accountant-company-settings'),
    description: (
      <ol style={{ textAlign: 'left', paddingInlineStart: 20 }}>
        <li>
          <Text>{i18next.t('tour:accountant-add-user')}</Text>
        </li>
        <li>
          <Text>{i18next.t('tour:accountant-apis')}</Text>
        </li>
        <li>
          <Text>{i18next.t('tour:accountant-budgeting')}</Text>
        </li>
        <li>
          <Text>{i18next.t('tour:accountant-keyfigures')}</Text>
        </li>
      </ol>
    )
  },
  {
    target: getElement('.avatar-menu'),
    title: '',
    description: (
      <div>
        <Paragraph>{i18next.t('tour:user-manual')}</Paragraph>
        <Paragraph>{i18next.t('tour:questions')}</Paragraph>
        <Paragraph>{i18next.t('tour:greetings')}</Paragraph>
        <Text>{i18next.t('tour:team-finadeck')}</Text>
      </div>
    )
  }
]
